import React from "react";
import styles from "./stressDelPortafoglioSuIpotesiRightChart.module.scss";
import colorsStore from "shared/store/colorsStore";
import { hexToRgba } from "utils/misc";

const StressDelPortafolioSuIpotesiRightChart = ({ dataItem, title }) => {
  if (!dataItem) {
    return null;
  }
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);

  const palettes = [
    colorsConfig.paletteChart1,
    colorsConfig.paletteChart2,
    colorsConfig.paletteChart3,
    colorsConfig.paletteChart4,
    colorsConfig.paletteChart5,
    colorsConfig.paletteChart6,
  ];

  return (
    <div className={styles.portfolioDeltaContainer}>
      <div className={styles.chartContainer}>
        {dataItem.map((row, index, array) => (
          <div
            key={index}
            className={`${styles.chartRow} ${index === array.length - 1 ? styles.lastRow : ""}`}
          >
            <div className={styles.chartColumn}>
              <div className={styles.gridLines}>
                <div className={styles.centerLine}></div>
                <div className={styles.sideLineLeft}></div>
                <div className={styles.sideLineRight}></div>
              </div>

              {row.weight < 0 ? (
                <div
                  className={`${styles.bar} ${styles.barLeft} ${styles.negativeBar}`}
                  style={{
                    width: `${(Math.abs(row.weight) / 20) * 50}%`,
                    left: `${50 - (Math.abs(row.weight) / 20) * 50}%`,
                    backgroundColor: palettes[index % palettes.length],
                  }}
                >
                  <span
                    className={`${styles.barLabel} ${styles.leftLabel}`}
                    style={{
                      backgroundColor: hexToRgba(
                        palettes[index % palettes.length],
                        0.2,
                      ),
                    }}
                  >
                    {row.weight.toFixed(2).replace(".", ",")}%
                  </span>
                </div>
              ) : row.weight > 0 ? (
                <div
                  className={`${styles.bar}  ${styles.barRight} ${styles.positiveBar}`}
                  style={{
                    width: `${(Math.abs(row.weight) / 20) * 50}%`,
                    left: "50%",
                    backgroundColor: palettes[index % palettes.length],
                  }}
                >
                  <span
                    className={`${styles.barLabel} ${styles.rightLabel}`}
                    style={{
                      backgroundColor: hexToRgba(
                        palettes[index % palettes.length],
                        0.2,
                      ),
                    }}
                  >
                    {row.weight.toFixed(2).replace(".", ",")}%
                  </span>
                </div>
              ) : (
                <div
                  className={`${styles.bar} ${styles.zeroBar}`}
                  style={{
                    width: "0px",
                    left: "50%",
                  }}
                >
                  <span
                    className={`${styles.barLabel} ${styles.zeroLabel} ${styles.zeroLabelLeft}`}
                    style={{
                      backgroundColor: hexToRgba(
                        palettes[index % palettes.length],
                        0.2,
                      ),
                    }}
                  >
                    0,0%
                  </span>
                  <span
                    className={`${styles.barLabel} ${styles.zeroLabel} ${styles.zeroLabelRight}`}
                    style={{
                      backgroundColor: hexToRgba(
                        palettes[index % palettes.length],
                        0.2,
                      ),
                    }}
                  >
                    0,0%
                  </span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className={styles.xAxisContainer}>
        <div className={styles.xAxisLabels}>
          <span>-10%</span>
          <span>-5%</span>
          <span>0</span>
          <span>5%</span>
          <span>10%</span>
        </div>
        {/* <div className={styles.lineLabels}></div> */}
      </div>
    </div>
  );
};

export default StressDelPortafolioSuIpotesiRightChart;
